import styled from 'styled-components'

import Field from 'components/Form/components/Field'

export const ProgressFieldStyled = styled(Field)`
  .Progress {
    margin: 0 0 0 auto;
  }
`
